import { criteriaActions } from 'actions/CriteriaActions';
import { defaultStrings } from 'js/config/config';
import { mapActions } from 'actions/MapActions';
import React from 'react';
import { parseDms } from 'dms-conversion';

export class LocationSelection extends React.Component {
  componentDidMount() {
    $('ul.tabs').tabs();
    $('ul.tabs li a:not(:first)').removeClass('active');
  }

  handleClick(event) {
    switch (event.target.text) {
      case 'Address':
        criteriaActions.toggleLocationDiv('address');
        break;
      case 'Lat/Long':
        criteriaActions.toggleLocationDiv('latlon');
        break;
      case 'Find on Map':
        criteriaActions.toggleLocationDiv('mapclick');
        break;
    }
  }

  latLongEntry(event) {
    let keyCode = event.which || event.keyCode;
    // Fire function on enter key
    if (keyCode === 13) {
      this.fireReverseGeoCode();
    }
  }

  fireReverseGeoCode() {
    let latlon = [document.getElementById('latitude').value, document.getElementById('longitude').value];
    let result = latlon.map(parseDms);

    if (
      !isNaN(result[0]) &&
      !isNaN(result[1]) &&
      result[0] >= -90 &&
      result[0] <= 90 &&
      result[1] >= -180 &&
      result[1] <= 180
    ) {
      mapActions.reverseGeocoder(result[0], result[1]);
    } else {
      document.getElementById('latitude').value = 'Invalid Entry';
      document.getElementById('longitude').value = 'Invalid Entry';
    }
  }

  fireAddressSearch() {
    let address = document.getElementById('geocoder_input').value;
    mapActions.searchAddress(address);
  }

  updateSnapToAddress(evt) {
    criteriaActions.updatedSnapToAddress(evt.target.checked);
  }

  render() {
    return (
      <div id={'locationSelection'}>
        <h3 className='location-selection-container__title'>
          <img src='app/images/circle_1.svg' alt='' />
          <span>{defaultStrings.locationSelectionLabel}</span>
        </h3>
        <div className={'margin--small white location-selectioncontainer__content'}>
          <div className='row'>
            <div className='col s12'>
              <div className='enter-location-container'>
                <h3 className='enter-location-container__label'>
                  <img className='title-icon' src='app/images/sm_icon_location.svg' alt='' />
                  <span>Enter Location</span>
                  <img
                    className={'info-icon'}
                    src='app/images/icon_info.svg'
                    title={defaultStrings.enterLocationMoreInfo}
                  />
                  <input
                    type='checkbox'
                    className='blue darken-2 filled-in'
                    checked={this.props.snapToAddress}
                    id='toggleSnapTo'
                    onChange={this.updateSnapToAddress.bind(this)}
                  ></input>
                  <label id='toggleSnapToLabel' htmlFor='toggleSnapTo'>
                    Snap to Address
                  </label>
                  <img
                    className={'info-icon'}
                    src='app/images/icon_info.svg'
                    title={defaultStrings.snapToAddressMoreInfo}
                  />
                </h3>
              </div>
              <ul className='tabs'>
                <li className='tab col tab-selector'>
                  <a href='javascript:;' className={'grey-text text-darken-4'} onClick={this.handleClick}>
                    Address
                  </a>
                </li>
                <li className='tab col tab-selector'>
                  <a href='javascript:;' className={'grey-text text-darken-4'} onClick={this.handleClick}>
                    Lat/Long
                  </a>
                </li>
                <li className='tab col tab-selector'>
                  <a href='javascript:;' className={'grey-text text-darken-4'} onClick={this.handleClick}>
                    Find on Map
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className={'location-inputs'}>
            <div
              id={'geocoderContainer'}
              className={`location-input-item padding--small ${
                this.props.activeLocationDiv === 'address' ? '' : 'hidden'
              }`}
            >
              <div id={'geocoder'}></div>
              <div
                className={'waves-effect waves-light btn blue darken-3 locate-btn'}
                id={'locate-address'}
                onClick={this.fireAddressSearch}
              >
                SEARCH
              </div>
            </div>

            <div
              id={'latlong'}
              className={`location-input-item padding--small ${
                this.props.activeLocationDiv === 'latlon' ? '' : 'hidden'
              }`}
            >
              <div className={'row'}>
                <div className={'input-field col s6 latlong-container'}>
                  <input id={'latitude'} onKeyDown={this.latLongEntry.bind(this)} type='text' />
                  <label htmlFor={'latitude'}>Latitude</label>
                </div>
                <div className={'input-field col s6 latlong-container'}>
                  <input id={'longitude'} onKeyDown={this.latLongEntry.bind(this)} type='text' />
                  <label htmlFor={'longitude'}>Longitude</label>
                </div>
              </div>
              <div className={'row'}>
                <div
                  className={'waves-effect waves-light btn blue darken-3 locate-btn'}
                  id={'locate-latlon'}
                  onClick={this.fireReverseGeoCode}
                >
                  SEARCH
                </div>
              </div>
            </div>

            <div
              id={'mapclick'}
              className={`location-input-item ${this.props.activeLocationDiv === 'mapclick' ? '' : 'hidden'}`}
            >
              <div className={'valign-wrapper fill'}>
                <div className={'valign center-align center-block'}>{defaultStrings.mapClickInstruction}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
